import { useEffect } from 'react'
import type { dia } from '@joint/core'

interface UseBeforeUnloadParams {
  graph: dia.Graph | null
}

/**
 * Warns user before closing/refreshing browser if there are unsaved changes.
 * Shows browser's native confirmation dialog.
 *
 * Note: Server saves should have already completed from handleBeforeFloorChange or auto-save.
 * We can't reliably wait for async operations in beforeunload event.
 */
export const useBeforeUnload = ({ graph }: UseBeforeUnloadParams) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Note: Server saves should have already completed from handleBeforeFloorChange or auto-save
      // We can't reliably wait for async operations in beforeunload

      // Show warning if there might be unsaved changes
      if (graph && graph.getCells().length > 0) {
        e.preventDefault()
        e.returnValue = '' // Required for Chrome
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [graph])
}
